import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const useUpdateStockRequired = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (vars: Parameters<typeof apiClient.updatePricingPlanStockRequired>[0]) => {
      await apiClient.updatePricingPlanStockRequired(vars);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [{ endpoint: "/api/data_report/product_report" }],
      });
    },
  });
};
